// @flow
import {createJstsPolygon, makePolygonPathClockwise} from "../../../Utils/MapUtils";
import type {LatLngLiteral} from "../../../Utils/MapUtils";

export const prepareServicePolygon = (serviceConfig: Object) => {
    var visualPolygons = serviceConfig.merged_polygons;
    var servicePolygons = serviceConfig.polygons_list;

    if (!visualPolygons || visualPolygons.length === 0 || !servicePolygons || servicePolygons.length === 0) {
        console.info(`empty visualPolygons or empty servicePolygons`);
    }

    var polygonPathsToShow = [];
    visualPolygons.forEach(function (polygonData) {
        var polygonPath = ((Object.values(polygonData.bounding_latlngs): any): Array<LatLngLiteral>);
        var polygon = new window.google.maps.Polygon({
            paths: polygonPath
        });
        var polygonJSTS = createJstsPolygon(polygon);
        var shouldShowPolygon = false;
        servicePolygons.forEach(function (servicePolygonData) {
            if (shouldShowPolygon) {
                return;
            }
            var servicePolygon = new window.google.maps.Polygon({
                paths: Object.values(servicePolygonData.bounding_latlngs)
            });
            var servicePolygonJSTS = createJstsPolygon(servicePolygon);
            shouldShowPolygon = polygonJSTS.intersects(servicePolygonJSTS);
        });
        if (shouldShowPolygon) {
            polygonPathsToShow.push(makePolygonPathClockwise(polygonPath));
        }

    });
    return polygonPathsToShow;
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/ServiceConfig/utils.js